
export default function DonateSection() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="donate" className="grid lg:grid-cols-2 min-h-[600px] lg:min-h-screen">
      {/* Left Side - Image with Overlay Text */}
      <div className="relative min-h-[400px] sm:min-h-[500px] lg:min-h-full order-2 lg:order-1">
        <img
          src="https://readdy.ai/api/search-image?query=compassionate%20hands%20gently%20holding%20and%20supporting%20another%20person%20hands%2C%20warm%20golden%20sunlight%20filtering%20through%2C%20simple%20soft%20blurred%20background%2C%20showing%20care%20and%20human%20connection%2C%20emotional%20support%20and%20kindness%20depicted%20through%20gentle%20touch%2C%20professional%20photography%20with%20shallow%20depth%20of%20field%20emphasizing%20hope%20and%20solidarity&width=800&height=1000&seq=donate-001&orientation=portrait"
          alt="Making a Difference"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent"></div>
        <div className="absolute bottom-8 sm:bottom-12 left-6 sm:left-12 text-white max-w-md">
          <p className="text-xs uppercase tracking-wider text-white/80 mb-3 sm:mb-4">MAKE A DIFFERENCE</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight drop-shadow-lg">
            Every<br />
            Contribution<br />
            Matters
          </h2>
        </div>
      </div>

      {/* Right Side - Donation Content */}
      <div className="bg-white flex items-center justify-center px-6 sm:px-8 lg:px-20 py-12 sm:py-16 lg:py-20 order-1 lg:order-2">
        <div className="max-w-lg text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#6a4bc3] mb-6 sm:mb-8 leading-tight">
            Transform Lives<br />
            Through Giving
          </h2>
          <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-8 sm:mb-12">
            Your donation provides critical support to survivors of kidnapping and crisis situations. Every contribution helps fund counseling services, legal advocacy, emergency assistance, and long-term recovery programs that restore hope and rebuild lives.
          </p>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-[#6a4bc3] text-white px-8 sm:px-12 py-3 sm:py-4 rounded-full font-semibold text-sm sm:text-base hover:bg-[#c9a24d] transition-all duration-300 hover:shadow-xl hover:-translate-y-1 flex items-center gap-3 mx-auto whitespace-nowrap cursor-pointer"
          >
            Start Donating
            <i className="ri-arrow-right-line"></i>
          </button>
          <div className="mt-6 sm:mt-8 flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-xs text-gray-500">
            <span className="flex items-center gap-2">
              <i className="ri-shield-check-line text-[#c9a24d]"></i>
              Secure Payment
            </span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-2">
              <i className="ri-file-list-line text-[#c9a24d]"></i>
              Tax Deductible
            </span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-2">
              <i className="ri-eye-line text-[#c9a24d]"></i>
              100% Transparent
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
